import script from "./CaseIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./CaseIndex.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__